import { AuthenticateWithRedirectCallback } from "@clerk/react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/callback/sso")({
  component: SsoCallbackPage,
});

function SsoCallbackPage() {
  return <AuthenticateWithRedirectCallback />;
}
